import { render } from "./disposition.vue?vue&type=template&id=677f56c4"
import script from "./disposition.js?vue&type=script&lang=js"
export * from "./disposition.js?vue&type=script&lang=js"

import "./disposition.vue?vue&type=style&index=0&id=677f56c4&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__